import DropdownActions from '@/components/table/dropdownActions';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { tenantsTableColumns } from '../constants';
import { ITenant } from '../types';

interface TableBodyProps {
  tenantsTableTableData?: ITenant[];
  handleModalPage: (type: string, tenant?: ITenant) => void;
  openModalWindow: (type: string, tenant?: ITenant) => void;
}

const TableBody = ({ tenantsTableTableData, openModalWindow, handleModalPage }: TableBodyProps) => {
  if (!tenantsTableTableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {tenantsTableTableData.map((tenant: ITenant) => {
        const truncatedName = tenant.name.length > 30 ? `${tenant.name.substring(0, 30)}...` : tenant.name;
        const truncatedEmail =
          tenant.primaryAdmin?.email.length > 30 ? `${tenant.primaryAdmin.email.substring(0, 30)}...` : tenant.primaryAdmin?.email;

        return (
          <TableRowWrapper key={tenant.id}>
            <TableRowCell width={tenantsTableColumns[0].width}>
              <TextCell>{truncatedName}</TextCell>
            </TableRowCell>
            <TableRowCell width={tenantsTableColumns[1].width}>
              <TextCell>{truncatedEmail}</TextCell>
            </TableRowCell>
            <TableRowCell width={tenantsTableColumns[2].width}>
              <DropdownActions
                items={[
                  {
                    name: 'Edit',
                    onClick: () => handleModalPage('firmInfo', tenant)
                  },
                  {
                    name: 'Delete',
                    onClick: () => openModalWindow('delete', tenant)
                  }
                ]}
              />
            </TableRowCell>
          </TableRowWrapper>
        );
      })}
    </>
  );
};

export default TableBody;
